import React, { useEffect, useState } from 'react'
import TableHeader from '../../../components/Common/TableView/TableHeader'
import { RoleWiseModule } from '../../../utils/generalUtils'
import { AdminAccess, SuperAdminAccess } from '../../../constant/commonConstants'
import CustomisedModal from '../../../components/Modal/CustomisedModal'
import { addSupportDetailsRequest, deleteSupportDetailsRequest, getSupportDetailsListRequest } from '../../../redux/admin/supportDetails/action'
import { connect } from 'react-redux'
import { CallSvg, DeleteSvg, EditSvg, EmailSvg2 } from '../../../components/CommonSvg'
import supportimg from "../../../assets/images/support-img.png";
import { Button } from 'reactstrap'
import AddEditSupportDetails from './AddEditSupportDetails'
import { Nav, NavItem, NavLink, TabContent } from "reactstrap";
import CommonPagination from '../../../components/Common/TableView/CommonPagination';
import Nodata from "../../../assets/images/no_data_found001.webp";
import { commonConfirmBox } from '../../../helper/messagehelpers'

function SupportDetails({ getSupportDetailsList, supportList, deleteSupportDetails, addSupportDetailsRequest, addSupportStatus, totalRecords }) {
    const [isModal, setIsModal] = useState(false)
    const [isEdit, setIsEdit] = useState(null)
    const [refModal, setRefModal] = useState(false)
    const [tab, setTab] = useState("Service");
    const [currentPage, setCurrentPage] = useState(1);
    const [dataPerPage, setDataPerPage] = useState(10);
    const [searchData, setSearchData] = useState("");
    const handleModalToggle = () => {
        setIsModal(true)
    }

    const dispatch = {
        searchText: searchData,
        type: tab === "Representative" ? 0 : 1,
        pagination: {
            limit: dataPerPage,
            page: currentPage,
            orderKey: "createdDate",
            orderBy: "ASC",
        },
    }

    useEffect(() => {
        getSupportDetailsList(dispatch)
    }, [currentPage, dataPerPage, searchData])

    useEffect(() => {
    
        setRefModal(true);
        if (addSupportStatus && refModal) {
            setIsEdit(null);
            setIsModal(false);
            setRefModal(false);
        }
    }, [addSupportStatus])

    return (
        <>
            <div className="container front_main">
                <TableHeader
                    hedingName={"Support Details"}
                    addModalData={handleModalToggle}
                    buttonNameModal={RoleWiseModule(AdminAccess, SuperAdminAccess) && "Add Support Details"}
                    searchBar={true}
                    setSearchData={setSearchData}
                    updateData={() => {
                        getSupportDetailsList(dispatch);
                    }}
                />
                <Nav tabs className="promotion_tab">
                    <NavItem>
                        <NavLink
                            className={tab === "Service" ? "active" : ""}
                            onClick={() => {
                                setCurrentPage(1)
                                getSupportDetailsList({ ...dispatch, type: 1 })
                                setTab("Service")
                            }}
                        >
                            Service Contact Details
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={tab === "Representative" ? "active" : ""}
                            onClick={() => {
                                setCurrentPage(1)
                                getSupportDetailsList({ ...dispatch, type: 0 })
                                setTab("Representative")
                            }}
                        >
                            Representative Details
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={tab} className="promotion_tab-content">
                    <div className="row support-list g-3 support-details">
                        {supportList?.length > 0 &&
                            supportList.map((d, index) => {
                                return (
                                    <div className="col-sm-6 col-md-4 col-lg-3" key={index}>
                                        <div className={d.serviceName?.includes("HRA CORPORATE") || d.serviceName?.includes("Pepsi Support Services") ? "support-data corporate" : "support-data"}>
                                            <div>
                                                <div className='actions'>
                                                    <Button
                                                        data-tooltip-content={"Delete"}
                                                        onClick={async () => {
                                                            const response = await commonConfirmBox(
                                                                "Are you sure you want to delete this support detail?"
                                                            );
                                                            if (response) {
                                                                deleteSupportDetails({ dispatchData: dispatch, value: { supportId: d.id } })
                                                            }

                                                        }}
                                                        className="text-danger mx-1 my-tooltip delete "
                                                    >
                                                        <DeleteSvg />
                                                    </Button>
                                                    <Button
                                                        data-tooltip-content={"Edit"}
                                                        className="text-primary mx-1 my-tooltip edit "
                                                        onClick={() => {
                                                            handleModalToggle()
                                                            setIsEdit(d)
                                                        }}
                                                    >
                                                        <EditSvg />
                                                    </Button>
                                                </div>
                                                <span className="support_img">
                                                    <img
                                                        src={d?.imagePath ? d.imagePath : supportimg}
                                                        alt="Image"
                                                    />
                                                </span>
                                                {tab === "Representative" ? <p>Representative Contact</p> : <p>{d.serviceName}</p>}
                                            </div>
                                            <div>
                                                {d.userName && <h6>{d.userName}</h6>}
                                                {d?.alternateNumber ? d?.alternateNumber && (
                                                    <a
                                                        href={"tel:" + d?.alternateNumber}
                                                        title={d?.alternateNumber}
                                                        className="d-inline-flex mt-1 w-100"
                                                    >
                                                        <CallSvg /> {d?.alternateNumber}
                                                    </a>
                                                ) :
                                                    d?.contactNumber && (
                                                        <a
                                                            href={"tel:" + d?.contactNumber}
                                                            title={d?.contactNumber}
                                                            className="d-inline-flex mt-1 w-100"
                                                        >
                                                            <CallSvg /> {d?.contactNumber}
                                                        </a>
                                                    )}
                                                {d?.emailId && (
                                                    <a
                                                        href={"mailto:" + d?.emailId}
                                                        title={d?.emailId}
                                                        className="d-inline-flex w-100"
                                                    >
                                                        <EmailSvg2 /> {d?.emailId}
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                    </div>
                    {totalRecords > 0 ? (
                        <CommonPagination
                            dataPerPage={dataPerPage}
                            totalData={totalRecords}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            setDataPerPage={setDataPerPage}
                        />
                    ) : (
                        <div className="d-flex justify-content-center">
                            <img alt="NO Data Found" className="no_data_found" src={Nodata} />
                        </div>
                    )}
                </TabContent >

            </div >

            {isModal && (
                <CustomisedModal
                    modalView={isModal}
                    customClass={"category-modal modal-lg"}
                    modalName={isEdit ? "Edit Support Details" : "Add Support Details"}
                    onModalDismiss={() => {
                        setIsModal(false)
                        setIsEdit(null);
                    }}
                >
                    <AddEditSupportDetails
                        isEdit={isEdit}
                        dispatch={dispatch}
                        tab={tab}
                        addSupportDetailsRequest={addSupportDetailsRequest}
                    />
                </CustomisedModal>
            )
            }
        </>
    )
}

const mapStateToProps = ({ SupportDetails }) => {
    let supportList = [];
    let totalRecords = null;
    let addSupportStatus = SupportDetails.addSupport?.status ? SupportDetails.addSupport.status : false
    if (SupportDetails.getSupportDetails?.list?.length > 0 && SupportDetails.getSupportDetails.list) {
        supportList = SupportDetails.getSupportDetails.list;
        totalRecords = SupportDetails.getSupportDetails.totalRecords;
    }
    console.log(addSupportStatus, "addSupportStatus")

    return {
        supportList: supportList,
        totalRecords: totalRecords,
        addSupportStatus: addSupportStatus
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getSupportDetailsList: (data) => dispatch(getSupportDetailsListRequest(data)),
        addSupportDetailsRequest: (data) => dispatch(addSupportDetailsRequest(data)),
        deleteSupportDetails: (data) => dispatch(deleteSupportDetailsRequest(data)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SupportDetails);